import {ReactNode} from "react";
import {css, cx} from "@panda/css";

interface IProps {
    children?: ReactNode;
    className?: string;
}

export const ModalEmptyLayout = (props: IProps) => {
    const {children, className} = props;

    return <div className={cx(innerWrap, className)}>{children}</div>;
};

const innerWrap = css({
    position: "relative",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    md: {
        height: "auto",
        borderRadius: "1"
    }
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

interface IProps {
    children?: ReactNode;
    className?: string;
}

export const ModalEmptyLayout = (props: IProps) => {
    const {children, className} = props;

    return <div className={cx(innerWrap, className)}>{children}</div>;
};

const innerWrap = css({
    position: "relative",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    md: {
        height: "auto",
        borderRadius: "1"
    }
});
